import { Box, TabPanels, TabPanel, TabPanelProps } from '@chakra-ui/react'
import moment from 'moment'

import {
  DetailDrawerHeader,
  DetailDrawerList,
  DetailDrawerListPaper,
  DetailDrawerSummary,
  DetailDrawerTabs,
  DetailDrawerListDeal,
  DetailDrawerListMedia,
  DetailDrawerListPressRelease,
  DetailDrawerListTrial,
} from 'modules/DetailDrawer'

import { SlideOver } from 'components'

import { IResponseBase } from 'api/types'
import { DetailDrawerListApprovals } from './DetailDrawerListApprovals'

import { IModel } from 'interfaces/model.interface'
import { ViewData } from 'interfaces/navigationPage.interface'

import {
  CandidateRankingData,
  DealsModel,
  MediaModel,
  PresentationsModel,
  PressReleasesModel,
} from 'config/common/baseModel'
import { VaccinesTrialsModel } from 'config/apps/Covid19/Science360/Vaccines/VaccinesModels'
import { ApprovalsModel } from 'config/common/baseModel/Approvals'

const StyledTabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (
  props
) => <TabPanel height='100%' p={0} {...props} />

type PropTypes<D extends Record<CandidateRankingData, any>> = {
  handleClose: () => void
  candidate: IResponseBase<Extract<keyof D, string>>
  model: IModel<D>
  title: Extract<keyof D, string>
  viewData: ViewData
}

function Detail<D extends Record<CandidateRankingData, any>>(
  props: PropTypes<D>
) {
  const { handleClose, candidate, model, title, viewData } = props
  return (
    <SlideOver show={true} handleClose={handleClose}>
      <DetailDrawerHeader
        isLoading={false}
        title={candidate && candidate[title]}
        handleClose={handleClose}
      />
      <DetailDrawerTabs
        tabs={[
          'Summary',
          'Papers',
          'Press Releases',
          'Trials',
          'Media',
          'Deals',
          'Approvals',
        ]}
      >
        <Box flexGrow={1} flexBasis={0} overflow='hidden'>
          <TabPanels height='100%'>
            <StyledTabPanel p={6} overflow='auto'>
              <DetailDrawerSummary rowData={candidate} model={model} />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={1}
                viewData={viewData}
                type='Papers'
                sortOrder={(x) => moment(x.publicationDate)}
                model={PresentationsModel}
                ids={candidate.covidPresentations}
                itemComponent={DetailDrawerListPaper}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={2}
                viewData={viewData}
                type='PressReleases'
                model={PressReleasesModel}
                sortOrder={(x) => moment(x.datePublished)}
                ids={candidate.covidPressReleases}
                itemComponent={DetailDrawerListPressRelease}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={3}
                viewData={viewData}
                model={VaccinesTrialsModel}
                sortOrder={(x) => moment(x.completedAt)}
                ids={candidate.covidTrials}
                itemComponent={DetailDrawerListTrial}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={4}
                viewData={viewData}
                type='Media'
                model={MediaModel}
                sortOrder={(x) => moment(x.datePublished)}
                ids={candidate.covidMedia}
                itemComponent={DetailDrawerListMedia}
              />
            </StyledTabPanel>
            <StyledTabPanel>
              <DetailDrawerList
                id={5}
                viewData={viewData}
                model={DealsModel}
                ids={candidate.covidDeals}
                itemComponent={DetailDrawerListDeal}
              />
            </StyledTabPanel>

            <StyledTabPanel>
              <DetailDrawerList
                id={7}
                viewData={viewData}
                model={ApprovalsModel}
                ids={candidate.covidApprovals}
                itemComponent={DetailDrawerListApprovals}
              />
            </StyledTabPanel>
          </TabPanels>
        </Box>
      </DetailDrawerTabs>
    </SlideOver>
  )
}

export default Detail
